import { useState, useEffect } from 'react';
import { createClient } from '@lingaai/supabase-client';

interface UseAppVersionReturn {
  updateAvailable: boolean;
  deployedAt: string | null;
  buildId: string;
  refresh: () => void;
  dismiss: () => void;
}

const BUILD_ID = typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_APP_VERSION ? (import.meta as any).env.VITE_APP_VERSION : 'local-dev';

export function useAppVersion(app: 'web' | 'crm'): UseAppVersionReturn {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [deployedAt, setDeployedAt] = useState<string | null>(null);

  useEffect(() => {
    console.log(`[useAppVersion] Initializing for app: ${app}`);
    const supabase = createClient();
    const channelName = `app-version-${app}`;

    const channel = supabase
      .channel(channelName)
      .on('broadcast', { event: 'new-version' }, (payload) => {
        console.log('[useAppVersion] New version detected:', payload);
        console.log('[useAppVersion] Payload structure:', JSON.stringify(payload, null, 2));
        setDeployedAt(payload.payload.deployedAt);
        setUpdateAvailable(true);
      })
      .subscribe((status) => {
        console.log(`[useAppVersion] Channel (${channelName}) status:`, status);
      });

    return () => {
      console.log(`[useAppVersion] Cleaning up channel: ${channelName}`);
      supabase.removeChannel(channel);
    };
  }, [app]);

  const refresh = () => {
    window.location.reload();
  };

  const dismiss = () => {
    setUpdateAvailable(false);
  };

  return {
    updateAvailable,
    deployedAt,
    buildId: BUILD_ID,
    refresh,
    dismiss,
  };
}
